import * as Braze from '@braze/web-sdk'
import getCachedContentCards from './getCachedContentCards.web'
import type { ContentCard } from '@braze/react-native-sdk'

export default function getContentCards() {
  return new Promise<ContentCard[]>((resolve, reject) => {
    Braze.requestContentCardsRefresh(() => {
      // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable -- Bubble up the error
      getCachedContentCards().then(resolve).catch(reject)
    })
  })
}
